import { render, staticRenderFns } from "./ComponentAdminUserNoteSeeding.vue?vue&type=template&id=cbfe1e3a&scoped=true"
import script from "./ComponentAdminUserNoteSeeding.vue?vue&type=script&lang=js"
export * from "./ComponentAdminUserNoteSeeding.vue?vue&type=script&lang=js"
import style0 from "./ComponentAdminUserNoteSeeding.vue?vue&type=style&index=0&id=cbfe1e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfe1e3a",
  null
  
)

export default component.exports